import { render } from "./list.vue?vue&type=template&id=5c58b312&scoped=true&ts=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"

import "./list.vue?vue&type=style&index=0&id=5c58b312&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c58b312"]])

export default __exports__